<sm-title-bar pageTitle="Followers" [backWithParams]="true"> </sm-title-bar>
<mat-card *ngIf="!loader && followersData.length > 0">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [showImageColumn]="true" [imageTemplate]="image" [dataSource]="followersData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [itemsPerPage]="10">
      </sm-data-table>
    </div>
  </mat-card>
  

  
  <ng-template #menuTemplate let-rowvalue>
    
    <!-- <button mat-menu-item (click)="openPublicPost(rowvalue)">
      <mat-icon class="material-icons-outlined">pages</mat-icon>
      <span>See public post</span>
    </button>
    <button mat-menu-item  (click)="openPublicMedia(rowvalue)">
      <mat-icon class="material-icons-outlined">perm_media</mat-icon>
      <span>See public media</span>
    </button> -->
    <button mat-menu-item  (click)="openMessages(rowvalue)">
      <mat-icon class="material-icons-outlined">chat</mat-icon>
      <span>Send message</span>
    </button>
    <!-- <button mat-menu-item (click)="reportAbuse(rowvalue)">
      <mat-icon class="material-icons-outlined">report</mat-icon>
      <span>Report abuse </span>
    </button> -->
  </ng-template>

  <ng-template #image let-objValue>
    <img
      [src]="
        objValue['profile_thumb'] !== null && objValue['profile_thumb'] !== 'null' && objValue['profile_thumb'] !== ''
          ? objValue['profile_thumb']
          : './assets/images/photo.png'
      "
      class="img-fluid rounded-circle"
    />
  </ng-template>



<!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->
  
  
  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && followersData.length == 0">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/follwer-1.png">
                 </div>
                 <mat-card-title>No followers yet
                </mat-card-title>
                 <mat-card-content>
                  Nobody is following your business or added as favorite in the LookzUp network. You can post feeds, promote with offers and communicate with your customers to get the followers. Build trust and grow.  
                </mat-card-content>
                <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openLink('https://lookzup.com/help')"
                  >
                    <mat-icon>help</mat-icon>
                   See help doc
                 </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in getting the list of followers or if your customer
                   encountered one while follow, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->